export const FOLDER_NAME = 'CenturionNY';
export const DATA_FILE_NAME = 'CenturionNYDataRefresh.json';
export const RECURRING_EVENTS_FILE_NAME = 'CenturionNYEvents.json';
export const EVENT_TYPES = { WALK_IN: 1, RESERVATION: 2, API: 3 };
export const EVENTS_PER_ROW = 5;
export const EVENTS_LENGTH_6 = 6;
export const EVENTS_LENGTH_17 = 17;
export const EVENTS_LENGTH_2 = 2;
export const NON_TABBED_MOBILE_EVENTS_LENGTH = 12;

export const API_EVENT_ID = -1;
